import gsap from "gsap";
import { prefersReducedMotion } from "./timeline-utils";

type DetailYearRowElement = HTMLElement & {
	_activeDotIndex?: number;
};

const DETAIL_DOT_HOVER_SCALE = 1.1;
const DETAIL_DOT_HOVER_DURATION_S = 0.2;

export function bindDetailDotHover(dotsHost: HTMLElement): () => void {
	if (prefersReducedMotion()) {
		return () => undefined;
	}

	const dots = Array.from(dotsHost.querySelectorAll<HTMLElement>(".historical-timeline__dot"));
	const cleanups = dots.map((dot) => {
		const onEnter = () => {
			gsap.to(dot, {
				scale: DETAIL_DOT_HOVER_SCALE,
				duration: DETAIL_DOT_HOVER_DURATION_S,
				ease: "power2.out",
				overwrite: "auto",
			});
		};

		const onLeave = () => {
			gsap.to(dot, {
				scale: 1,
				duration: DETAIL_DOT_HOVER_DURATION_S,
				ease: "power2.out",
				overwrite: "auto",
			});
		};

		dot.addEventListener("mouseenter", onEnter);
		dot.addEventListener("mouseleave", onLeave);

		return () => {
			dot.removeEventListener("mouseenter", onEnter);
			dot.removeEventListener("mouseleave", onLeave);
			gsap.killTweensOf(dot);
		};
	});

	return () => {
		cleanups.forEach((cleanup) => cleanup());
	};
}

export function updateDetailYearDotsActive(
	row: DetailYearRowElement,
	activeIndex: number
): void {
	const dots = Array.from(row.querySelectorAll<HTMLElement>(".historical-timeline__dot"));

	dots.forEach((dot, index) => {
		const isActive = index === activeIndex;
		dot.classList.toggle("is-active", isActive);

		if (dot instanceof HTMLButtonElement) {
			if (isActive) {
				dot.setAttribute("aria-current", "true");
			} else {
				dot.removeAttribute("aria-current");
			}
		}
	});

	row._activeDotIndex = activeIndex;
}
